import { Mail } from 'lucide-react'

/**
 * SupportEmailCTA - A footer banner encouraging users to email support.
 * Use on Landing page and Dashboard.
 * 
 * Usage: <SupportEmailCTA />
 */
export default function SupportEmailCTA() {
  return (
    <div className="bg-slate-100 dark:bg-slate-800/50 border-t border-slate-200 dark:border-slate-700 py-4 px-4 text-center">
      <div className="flex items-center justify-center gap-2 text-sm text-slate-500 dark:text-slate-400">
        <Mail className="w-4 h-4" />
        <span>
          Suggestions, comments, concerns, or ideas? Email us at{' '}
          <a 
            href="mailto:support@zennago.com" 
            className="text-zenna-violet hover:underline font-medium"
          >
            support@zennago.com
          </a>
        </span>
      </div>
    </div>
  )
}